import { call, put, takeEvery } from "redux-saga/effects";
import { getPlaceDetails } from "redux/actions/UserGoogleMap";
import store from "redux/store";
import {
	GET_GEOCODE_FAILED,
	GET_GEOCODE_REQUESTED,
	GET_GEOCODE_SUCCESS,
  GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED,
  GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED,
  GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS,
  GET_GOOGLE_MAP_DIRECTION_FAILED,
  GET_GOOGLE_MAP_DIRECTION_REQUESTED,
  GET_GOOGLE_MAP_DIRECTION_SUCCESS,
  GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS,
  GET_GOOGLE_MAP_PLACE_DETAILS_FAILED,
  GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS,
  GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED,
  GET_GOOGLE_NEARBY_SEARCH_FAILED,
  GET_GOOGLE_NEARBY_SEARCH_REQUESTED,
  GET_GOOGLE_NEARBY_SEARCH_SUCCESS,
  GET_LOCATIONCHECK_FAILED,
  GET_LOCATIONCHECK_REQUESTED,
  GET_LOCATIONCHECK_SUCCESS,
} from "resources/actionTypes";
import { autocompleteApi, directionApi, geocodeApi, nearbysearchApi, placeApi, } from "services/GoogleMapService";
import { locationCheck } from "services/LocationCheckService";
import { onLoaderTrigger } from "redux/actions/CommonAction";
import { toast } from "react-toastify";

function* fetchAutoComplete(action) {
  try {
    const payload = action.payload || {};
    const userAutoComplete = yield call(autocompleteApi, payload);
    yield put({
      type: GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS,
      userAutoComplete: userAutoComplete,
    });
  } catch (e) {
    yield put({ type: GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED, message: e.message });
  }
}
export function* autoCompleteSaga() {
  yield takeEvery(GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED, fetchAutoComplete);
}
function* fetchNearBySearch(action) {
  try {
    const payload = action.payload || {};
    const userNearBySearch = yield call(nearbysearchApi, payload);
    yield put({
      type: GET_GOOGLE_NEARBY_SEARCH_SUCCESS,
      userNearBySearch: userNearBySearch,
    });
  } catch (e) {
    yield put({ type: GET_GOOGLE_NEARBY_SEARCH_FAILED, message: e.message });
  }
}
export function* nearBySearchSaga() {
  yield takeEvery(GET_GOOGLE_NEARBY_SEARCH_REQUESTED, fetchNearBySearch);
}

function* fetchPlaceDetails(action) {
  try {
    const payload = action.payload || {};
    const userPlaceDetails = yield call(placeApi, payload);
    if(payload.type === 'pickup')
    {
      yield put({
        type: GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS,
        userPlaceDetails: {
        pickup:userPlaceDetails},
      }); 
    }
    else if(payload.type === 'drop')
    {
      yield put({
        type: GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS,
        userPlaceDetails: {
        drop:userPlaceDetails}
      });
    }
   
    
  } catch (e) {
    yield put({
      type: GET_GOOGLE_MAP_PLACE_DETAILS_FAILED,
      message: e.message,
    });
  }
}
export function* placeDetailsSaga() {
  yield takeEvery(GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED, fetchPlaceDetails);
}

function* fetchDirection(action) {
  try {
    const payload = action.payload || {};
    const userDirection = yield call(directionApi, payload);
    yield put({
      type: GET_GOOGLE_MAP_DIRECTION_SUCCESS,
      userDirection: userDirection,
    });
  } catch (e) {
    yield put({ type: GET_GOOGLE_MAP_DIRECTION_FAILED, message: e.message });
  }
}
export function* directionSaga() {
  yield takeEvery(GET_GOOGLE_MAP_DIRECTION_REQUESTED, fetchDirection);
}

function* fetchGeocode(action) {
  try {
    const payload = action.payload || {};
    const userGeocode = yield call(geocodeApi, payload);
    yield put({
      type: GET_GEOCODE_SUCCESS,
      userGeocode: userGeocode,
    });
    if(userGeocode){
      store.dispatch(getPlaceDetails({type:'pickup',place_id:userGeocode?.results[0]?.place_id}))
    }
   
  } catch (e) {
    yield put({ type: GET_GEOCODE_FAILED, message: e.message });
  }
}
export function* geocodeSaga() {
  yield takeEvery(GET_GEOCODE_REQUESTED, fetchGeocode);
}

//Location Check
function* fetchLocationCheck(action){
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userLocationCheck = yield call(locationCheck, payload);
  if(userLocationCheck?.success){
    yield put({
      type: GET_LOCATIONCHECK_SUCCESS,
      userLocationCheck: userLocationCheck,
    });
  }
    else{
      yield put({
        type: GET_LOCATIONCHECK_FAILED,
        message: userLocationCheck?.message,
      });
      toast.error(userLocationCheck?.message)
    }
    store.dispatch(onLoaderTrigger(false));
  }
export function* locationCheckSaga() {
  yield takeEvery(GET_LOCATIONCHECK_REQUESTED, fetchLocationCheck);
}

